<template>
    <div>
      <b-row v-if="isPresent">
        <b-col>
          <b-alert show variant="warning"><span v-html="info.helpPrompt"></span></b-alert>
        </b-col>
      </b-row>
    </div>
</template>

<script>
  import axios from "axios"

  export default {
    data() {
      return {
          info: { },
      }
    },
    props: {
        lifecycleStatus: [String]
    },
    validations: {
    },

    computed: {
      isPresent: function() {
        return this.info && this.info.helpPrompt
      },
    },

    created() {
      this.loadStatusInfo();
    },

    methods: {
      async loadStatusInfo() {
         await axios.get(`${process.env.VUE_APP_API_BASE_URL}/meta/status/${this.lifecycleStatus}`)
            .then(response => {
                this.info = response.data;
            })
      },
    }
  }
</script>

<style scoped>
.form-group .col-form-label {
    font-weight: 750;
}

p {
    margin-top: 0;
    margin-bottom: 0rem
}
</style>